export const scoreRecordToSet = (input: Record<'score', number>[]) => Array.from(new Set(input.map((item) => item.score)))
